module.exports = __webpack_public_path__ + "img/save-time-shopping.dd2fe122.jpg";